import {
    ADD_BASKET,
    DELETE_BASKET,
    CLEAR_BASKET,
    CHANGE_COUNT_BASKET,
    CHANGE_CITY,
    CHANGE_PHONE,
} from './type';

export function addBasket(items) {
    return {
        type: ADD_BASKET,
        payload: items,
    };
}

export function deleteBasket(id) {
    return {
        type: DELETE_BASKET,
        payload: id,
    };
}

export function clearBasket() {
    return {
        type: CLEAR_BASKET,
    };
}

export function changeCountBasket(id, count) {
    return {
        type: CHANGE_COUNT_BASKET,
        payload: { id, count },
    };
}

export function changeCity(city) {
    return {
        type: CHANGE_CITY,
        payload: city,
    };
}

export function changePhone(phone) {
    return {
        type: CHANGE_PHONE,
        payload: phone,
    };
}
